export default {"src":"/_next/static/media/not-valid.f1720eca.svg","height":512,"width":790,"blurWidth":0,"blurHeight":0};